import type { ComponentType, SVGProps } from 'react';
import CargoPallet from './cargo-pallet';
import Containers from './containers';
import MoneyInHand from './money-in-hand';
import PackageOpen from './package-open';
import ShipWithContainer from './ship-with-container';
import ShippingBox from './shipping-box';
import Truck from './truck';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

const ICON_MAP: Record<string, IconComponent> = {
    'ship-with-container': ShipWithContainer,
    'shipping-box': ShippingBox,
    'cargo-pallet': CargoPallet,
    'money-in-hand': MoneyInHand,
    containers: Containers,
    truck: Truck,
    'package-open': PackageOpen,
};

export type IsomorphicIconName = keyof typeof ICON_MAP;

export function getIsomorphicIcon(name: string): IconComponent | null {
    return ICON_MAP[name] ?? null;
}

type IconProps = SVGProps<SVGSVGElement> & {
    name: IsomorphicIconName;
};

export function IsomorphicIcon({ name, className, ...props }: IconProps) {
    const Component = ICON_MAP[name];
    if (!Component) {
        return null;
    }

    return <Component className={className} {...props} />;
}
